import { LoginRegistrationForm } from "./LoginRegistrationForm";

export default LoginRegistrationForm;
